import React, { FC } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { IconTextFieldProps } from './types';

const IconTextField: FC<IconTextFieldProps> = ({ iconStart, iconEnd, InputProps, ...props }) => (
  <TextField
    {...props}
    InputProps={{
      ...InputProps,
      startAdornment: iconStart ? <InputAdornment position="start">{iconStart}</InputAdornment> : null,
      endAdornment: iconEnd ? <InputAdornment position="end">{iconEnd}</InputAdornment> : null,
    }}
  />
);

export default IconTextField;
